import Banner from '../NAComps/Banner';
import OnePicture from '../NAComps/OnePicture';
import SectionA from '../NAComps/SectionA';
import TabSwiperA from '../NAComps/TabSwiperA';
import ModuleA from '../NAComps/ModuleA';
import ModuleB from '../NAComps/ModuleB';
import ModuleC from '../NAComps/ModuleC';
import SectionB from '../NAComps/SectionB';
import TabSwiperB from '../NAComps/TabSwiperB';
import SectionC from '../NAComps/SectionC';
import AccordionVideo from '../NAComps/AccordionVideo';
import SectionD from '../NAComps/SectionD';
import FAQ from '../NAComps/FAQ';
import SectionE from '../NAComps/SectionE';
import SectionF from '../NAComps/SectionF';
import TabSwiperC from '../NAComps/TabSwiperC';
import GraphicItems from '../NAComps/GraphicItems';
import Users from '../NAComps/Users';
import QuoteFromMedia from '../NAComps/QuoteFromMedia';
import VS from '../NAComps/VS';
import WhatInBox from '../NAComps/WhatInBox';
import TC from '../NAComps/TC';
import PageNavLeft from '../NAComps/PageNavLeft';
import K1 from '../NAComps/K1';
import K2 from '../NAComps/K2';
import K3 from '../NAComps/K3';
import K4 from '../NAComps/K4';
import K5 from '../NAComps/K5';
import K6 from '../NAComps/K6';

import style from './na.module.scss';
import { useLang } from '@/i18n';

const TempNA = () => {
    const { t } = useLang('dp3.page_v2.KSP');

    return (
        <div className={`${style.temp} GtmModuleData-section`} data-section-id={'dp3-TempNA'} data-section-title={'dp3-TempNA'}>
            {/* 子豪 */}
            <Banner />
            <div className="range1">
                <OnePicture />
            </div>
            <div className="range2">
                <SectionA />
                <TabSwiperA />
                <ModuleA />
                <ModuleB />
                <ModuleC />
            </div>

            <SectionB />
            <TabSwiperB />

            {/* 开庆 */}
            <div className="black" style={{ backgroundColor: '#000' }}>
                <K1 />
                <K2 />
                <K3 />
                <K4 />
                <K5 />
                <K6 />
            </div>

            {/* 伍英 */}
            <SectionC />
            <AccordionVideo />
            <SectionD />
            <FAQ />
            <SectionE />
            <SectionF />
            <TabSwiperC />
            <GraphicItems />
            <div className="range3">
                <Users />
            </div>
            <QuoteFromMedia />
            <div className="range4">
                <VS />
            </div>
            <WhatInBox />
            <TC />

            {/* 左侧锚点 */}
            <PageNavLeft
                triggerElement=".dp3-crowdfunding"
                enterElement="#OnePicture"
                steps={[
                    { text: t('item1'), href: '#OnePicture' },
                    { text: t('item2'), href: '#SectionA' },
                    { text: t('item3'), href: '#Users' },
                    { text: t('item4'), href: '#VS' },
                ]}
            />
        </div>
    );
};

export default TempNA;
